import React, { Component, useEffect, useState } from "react";

import { DTO as BcsDTO } from "@10x/bcs";
import Strings from "@my-dld/assets/strings";
import Popup from "./Popup/Popup";
import { JQModal } from "./Popup/Utils";
import { formatAppDate } from "@my-dld/utils/Utils";
import { Gated } from "@10x/feature-gate";
import { getBCSCertDetailUrl, getBCSCertificate } from "@10x/bcs/dist/api";
import { hideLoading, showErrorMessage, showLoading } from "@my-dld/utils/UIUtils";
import { getConsumerId } from "../configApp";

interface Props {
	propertyName?: string;
	rating?: BcsDTO.BCSRating;
	onReValuate?: () => void;
}

interface State {
}

class BcsRating extends Component<Props, State> {
	render() {
		const { rating, propertyName, onReValuate } = this.props;
		if ( rating != undefined && rating.id != undefined && rating.id !== 0 ) {
			return (
				<>
					<div className={ "star-rating-container" } onClick={ this.onShowInfo }>
						<StarRatingView rating={ rating.id }/>
						<span className="fa fa-info-circle"/>
					</div>
					<Popup
						id={ "bcsBuildingDetail" } showIcon={ false }
						modalSubContainer={ "modal-dialog modal-dialog-centered modal-lg" }
						title={ Strings.bcs_building_Survey_details }>

						<div className="flex-grid bcs-survey-detail">
							<div className="flex-full">
								<span>{ Strings.building_name }</span>
								<span>{ propertyName }</span>
							</div>
							<div className="flex-full">
								<span>{ Strings.star_building_rating }</span>
								<span> <StarRatingView rating={ rating.id }/></span>
							</div>
							{ rating.surveyDate &&
								<div className="flex-full">
									<span>{ Strings.date_issued }</span>
									<span>{ formatAppDate( rating.surveyDate ) }</span>
								</div>
							}
						</div>
						<div className="d-flex justify-content-center">
							{ ( rating.buildingId ) && <>
								<button
									className="btn btn-grey me-2"
									onClick={ this.downloadCertificate }>{ Strings.download_certificate }</button>
								<button
									className="btn btn-grey me-2"
									onClick={ this.downloadDetailedCertificate }>{ Strings.download_certificate_details }</button>
							</>
							}
							<Gated featureId={ "bcsReclassification" }>
								{ onReValuate != null && <>
									<button
										className="btn btn_1"
										onClick={ this.onReEvaluate }>{ Strings.re_valuate }</button>
								</> }
							</Gated>
						</div>
					</Popup>
				</> );
		}
		return null;
	}

	onShowInfo = () => {
		JQModal( "bcsBuildingDetail" ).show();
	};
	onReEvaluate = () => {
		JQModal( "bcsBuildingDetail" ).hide( () => {
			this.props.onReValuate?.();
		} );
	};
	downloadDetailedCertificate = () => {
		const { rating } = this.props;
		if ( rating?.buildingId ) {
			let bcsCertDetailUrl = getBCSCertDetailUrl( rating?.buildingId );
			let uri = `${ bcsCertDetailUrl }?consumer-id=${ getConsumerId( bcsCertDetailUrl ) }`;
			this.downloadPDF( uri, "_detail" );
		}

	};
	downloadCertificate = () => {
		const { rating } = this.props;
		const buildingId = rating?.buildingId;
		if ( buildingId ) {
			JQModal( "bcsBuildingDetail" ).hide( () => {
				showLoading();
				getBCSCertificate( buildingId ).then( x => {
					hideLoading();
					this.downloadPDF( x.certificateUrl, "c", false );
				} ).catch( e => {
					hideLoading();
					showErrorMessage( e );
				} );
			} );
		}
	};
	downloadPDF = ( url: string, idX: string = "", hideModal: boolean = true ) => {
		const c = () => {
			function download() {
				window.open( url, "bcs_certificate" + idX );
			}

			download();
		};
		if ( hideModal )
			JQModal( "bcsBuildingDetail" ).hide( c );
		else c();
	};
}

export function StarRatingView( props: { rating: number } ) {
	let { rating } = props;
	let [ showPlus, setShowPlus ] = useState( false );
	let [ starCount, setStarCount ] = useState( 0 );
	useEffect( () => {
		if ( rating > 4 ) {
			setStarCount( 4 );
			setShowPlus( true );
		} else {
			setStarCount( rating );
			setShowPlus( false );
		}
	}, [ rating ] );

	if ( !rating ) return null;
	return <div className={ "bcs-star-container" }>
		{ [ ...Array( starCount ) ].map( ( value, index ) => {
			return <Star key={ index }/>;
		} ) }
		{ showPlus && <StarPlus/> }
	</div>;
}

export default BcsRating;

function Star( props: React.SVGProps<SVGSVGElement> ) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			{ ...props }
			className="bcs-start-icon"
		>
			<path
				data-name="Path 1757"
				d="M19.66 6.843l-6.229-.91L10.575.295a.626.626 0 00-1.064 0L6.733 5.933l-6.229.91a.592.592 0 00-.331 1l4.5 4.4-1.064 6.193a.6.6 0 00.863.626l5.567-2.931 5.646 2.931a.593.593 0 00.863-.626l-1.064-6.193 4.5-4.4a.592.592 0 00-.324-1z"
				fill="#fedb41"
			/>
			<path
				data-name="Path 1758"
				d="M19.991 7.848l-4.5 4.4 1.064 6.193a.593.593 0 01-.863.626l-5.646-2.931V0a.585.585 0 01.532.3l2.857 5.638 6.229.91a.592.592 0 01.327 1z"
				fill="#f1c235"
			/>
		</svg>
	);
}

function StarPlus( props: React.SVGProps<SVGSVGElement> ) {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" className="bsc-rating-plus" { ...props }>
			<defs>
				<linearGradient
					id="prefix__a"
					x1={ 0.5 }
					x2={ 0.486 }
					gradientUnits="objectBoundingBox"
				>
					<stop offset={ 0 } stopColor="#d9ad26"/>
					<stop offset={ 1 } stopColor="#e8c52a"/>
				</linearGradient>
			</defs>
			<g data-name="Group 775" transform="translate(-732 -1545)">
				<rect
					data-name="Rectangle 3077"
					width={ 93 }
					height={ 19 }
					rx={ 4 }
					transform="translate(732 1545)"
					fill="url(#prefix__a)"
				/>
				<path
					data-name="Path 1772"
					d="M757.9 1550.28a5.006 5.006 0 012.145.405 2.867 2.867 0 011.275 1.1 3.065 3.065 0 01.42 1.613 3.416 3.416 0 01-.435 1.733 2.953 2.953 0 01-1.305 1.187 4.848 4.848 0 01-2.138.428h-1.23V1560H754.5v-9.72zm-.255 4.755a2.407 2.407 0 001.41-.352 1.4 1.4 0 00.495-1.222 1.351 1.351 0 00-.442-1.1 1.883 1.883 0 00-1.238-.367h-1.24v3.045zm12.875 3.135h4.41v1.83h-6.54v-9.72h2.13zm14.49 2.04a4.77 4.77 0 01-2.415-.548 3.251 3.251 0 01-1.373-1.485 5.1 5.1 0 01-.427-2.138v-5.759h2.13v5.505a3.342 3.342 0 00.495 1.957 1.971 1.971 0 001.725.7 1.859 1.859 0 001.65-.7 3.124 3.124 0 00.48-1.808v-5.654h2.13v5.72a4.609 4.609 0 01-.57 2.422 3.342 3.342 0 01-1.553 1.36 5.652 5.652 0 01-2.272.428zm14.61 0a6.234 6.234 0 01-3.825-1.17l.96-1.485a5.089 5.089 0 002.73.885 2.789 2.789 0 001.343-.27.872.872 0 00.487-.81.909.909 0 00-.157-.548 1.539 1.539 0 00-.555-.42q-.4-.2-1.193-.517l-.345-.135a10.97 10.97 0 01-1.545-.72 2.725 2.725 0 01-.93-.885 2.491 2.491 0 01-.345-1.365 2.246 2.246 0 01.525-1.523 3.067 3.067 0 011.35-.892 5.337 5.337 0 011.755-.285 5.822 5.822 0 011.733.278 6.582 6.582 0 011.7.817l-.975 1.47a7.079 7.079 0 00-1.275-.63 3.6 3.6 0 00-1.2-.2 2 2 0 00-1.088.24.737.737 0 00-.37.655.749.749 0 00.15.457 1.569 1.569 0 00.54.4 10.234 10.234 0 001.13.473l.33.12a13.477 13.477 0 011.55.675 2.808 2.808 0 011 .9 2.607 2.607 0 01.4 1.515 2.626 2.626 0 01-.51 1.642 3.047 3.047 0 01-1.387 1 5.616 5.616 0 01-1.983.328z"
					fill="#fff"
					stroke="rgba(91,68,0,0.16)"
					strokeWidth={ 0.5 }
				/>
				<path
					data-name="Path 1757"
					d="M819.342 1553.482l-3.171-.463-1.454-2.87a.319.319 0 00-.542 0l-1.414 2.87-3.171.463a.3.3 0 00-.168.511l2.293 2.238-.542 3.151a.3.3 0 00.439.319l2.834-1.492 2.874 1.492a.3.3 0 00.44-.319l-.541-3.153 2.293-2.238a.3.3 0 00-.17-.509z"
					fill="#fff"
				/>
				<path
					data-name="Path 1758"
					d="M819.51 1553.995l-2.292 2.238.541 3.153a.3.3 0 01-.439.319l-2.874-1.492V1550a.3.3 0 01.271.15l1.454 2.87 3.171.463a.3.3 0 01.168.512z"
					fill="#fef1cd"
				/>
				<g data-name="Group 751">

				</g>
				<path
					data-name="Path 1757"
					d="M747.342 1553.482l-3.171-.463-1.454-2.87a.319.319 0 00-.542 0l-1.414 2.87-3.171.463a.3.3 0 00-.168.511l2.293 2.238-.542 3.151a.3.3 0 00.439.319l2.834-1.492 2.874 1.492a.3.3 0 00.44-.319l-.541-3.153 2.293-2.238a.3.3 0 00-.17-.509z"
					fill="#fff"
				/>
				<path
					data-name="Path 1758"
					d="M747.51 1553.995l-2.292 2.238.541 3.153a.3.3 0 01-.439.319l-2.874-1.492V1550a.3.3 0 01.271.15l1.454 2.87 3.171.463a.3.3 0 01.168.512z"
					fill="#fbeabc"
				/>
			</g>
		</svg>
	);
}
